import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction, createLazyComponent, type LazyComponent } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "FreezeDry" */ './lazyIndex'),
    {
        name: 'FreezeDry',
    }
);

export const RestoreItemsDialog: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.RestoreItemsDialog
);
export const RestoreItemsDialogFluentV9: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.RestoreItemsDialogFluentV9
);
export const lazyCreateOrUpdateMainWindowItem: LazyAction<
    typeof lazyIndex.createOrUpdateMainWindowItem,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.createOrUpdateMainWindowItem);
export const lazyKickOffFreezeDry: LazyAction<
    typeof lazyIndex.kickOffFreezeDry,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.kickOffFreezeDry);
export const lazySetShouldInitializeFreezeDry: LazyAction<
    typeof lazyIndex.setShouldInitializeFreezeDry,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setShouldInitializeFreezeDry);
